export const CAMPAIGN_API_IFRAME = "82bcccae-c414-43a0-9f90-56535c090d39";
